import { Button } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface IStickyScrollBtn {
  isSticky: boolean;
  stickyRef: React.Ref<HTMLDivElement>;
  scrollToFilters(): void;
  buttonText: string;
}

export function StickyScrollBtn({ stickyRef, isSticky, scrollToFilters, buttonText }: IStickyScrollBtn) {
  return (
    <div ref={stickyRef} data-testid="StickyScrollBtn" className={cn(styles['block'], isSticky && styles['sticky'])}>
      <div className={styles['button_wrap']}>
        <Button onClick={scrollToFilters}>{buttonText}</Button>
      </div>
    </div>
  );
}
